export {
  default 
} from "./rating";
